import React from 'react';
import PropTypes from 'prop-types';

import { isMobile as isMobileDevice, isPreorder, isWHW, isWHWP2 } from '../../common/Helpers/index';
import SubHeading from '../../common/Heading/subhead';

const ShippingSubHeader = (props) => {
  const { subHeading, subHeadingSSDISPU, subheadingCancellation, shippingInfoLineDetails: { lines = [] } = {} } = props;
  const [{ ispuEligible, sddEligible } = {}] = lines;
  let content = [];
  const isMobile = isMobileDevice();
  if (isPreorder()) {
    content = [props.subHeadingPreorder];
  } else if (isWHW() ||isWHWP2()) {
    content.push();
  } else {
    content.push(ispuEligible || sddEligible ? subHeadingSSDISPU : subHeading, subheadingCancellation);
  }
  return content.map((subtitle, index) => (
    <SubHeading primitive="p" className={index && isMobile ? 'marginTop20' : ''} maxWidth={isMobile ? '341px' : ''} color="secondary">
      {subtitle}
    </SubHeading>
  ));
};

ShippingSubHeader.propTypes = {
  shippingInfoLineDetails: PropTypes.object,
  subHeadingSSDISPU: PropTypes.string,
  subHeading: PropTypes.string,
  subHeadingPreorder: PropTypes.string,
  subheadingCancellation: PropTypes.string,
};

export default React.memo(ShippingSubHeader);
